import React, { useContext } from 'react'
import { Context } from '../storage/MainContext'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'

const PrivateRoute = ({ children }) => {
  const { user } = useContext(Context)
  return user?.accessToken ? children : <Navigate to={'/login'} />
}

PrivateRoute.propTypes = {
  children: PropTypes.element,
}

export default PrivateRoute
